import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { useFormikContext } from "formik";
import AddButton from "../buttons/button";
import CloseIcon from "../../assets/icons/close-icon";
import { useDispatch } from "react-redux";
import LoadingOverlay from "../helper-components/overlay-loading";
import {
  invoicePastAction,
  invoiceViewAction,
} from "../../redux/actions/invoices-action";
import TabsComponent from "../helper-components/tabs-component";
import { truncateString } from "../helper-components/helper-function";
import SelectIcon from "../../assets/icons/select-icon";
import errorToast from "../helper-components/error-toast";
import moment from "moment";
import { url } from "../../redux/config";
import { api } from "../../redux/apis/api";
import { useHotkeys } from "react-hotkeys-hook";

export default function BillingPastBillPanel({ open, setOpen }) {
  const addref = useRef();

  useHotkeys("a", () => {
    if (addref.current) {
      addref.current.click();
    }
  });
  const [selectedItems, setSelectedItems] = useState([]);
  const { values, setFieldValue } = useFormikContext();
  const [selectedRow, setSelectedRow] = useState("");
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const phone = values?.phone?.label;
  const [pastorders, setPastOrders] = useState({});
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [currentTab, setCurrentTab] = useState("Past Bills");
  const itemTabs = ["Past Bills", "Top Products"];
  useEffect(() => {
    setLoading(true);
    if (open) {
      dispatch(
        invoicePastAction(
          {
            pageNumber: currentPage,
            pageSize: pageSize,
            phone,
          },
          onSuccess,
          onError
        )
      );
    }
  }, [currentPage, open]);

  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setPastOrders(data?.data ?? {});
    setDataCount(data?.data?.totalCount);
  };
  const onError = () => {
    setError(true);
    setLoading(false);
  };

  function selectBillFun(id) {
    setLoading(true);
    setSelectedRow(id);
    if (id) {
      dispatch(invoiceViewAction(id, onSuccessView, onErrorView));
    } else {
      setPastOrders({
        ...pastorders,
        itemsData: [],
      });
    }
  }
  const onSuccessView = (data) => {
    setLoading(false);

    const uniqueItems = [];
    const itemIds = new Set();

    (data?.data?.[0]?.itemData || []).forEach((item) => {
      const sellableQty = parseFloat(item?.total_sellable_quantity) || 0;

      if (!itemIds.has(item.item_id) && sellableQty > 0) {
        itemIds.add(item.item_id);
        uniqueItems.push(item);
      }
    });

    setPastOrders({
      ...pastorders,
      itemsData: uniqueItems,
    });
  };

  const onErrorView = (data) => {
    setLoading(false);
    setPastOrders({ ...pastorders, itemsData: [] });
    errorToast(data?.data?.message);
  };
  const handleCheckboxChange = (e, type = "single") => {
    const keyToUse = currentTab === "Past Bills" ? "itemsData" : "topProducts";
    const itemsList = pastorders?.[keyToUse];

    if (type === "all") {
      const allIds = itemsList?.map((item) => item?.item_id);
      const isAllSelected = allIds?.every((id) => selectedItems.includes(id));
      setSelectedItems(isAllSelected ? [] : allIds);
    } else {
      const itemId = e.target.id;
      if (e.target.checked) {
        setSelectedItems((prev) => [...prev, itemId]);
      } else {
        setSelectedItems((prev) => prev.filter((id) => id !== itemId));
      }
    }
  };

  const isItemChecked = (rowData) => selectedItems.includes(rowData?.item_id);
  const handleQuantityChange = (e, itemId) => {
    const newQty = e.target.value;

    if (newQty === "" || !isNaN(newQty)) {
      const keyToUpdate =
        currentTab === "Past Bills" ? "itemsData" : "topProducts";

      const updatedItems = pastorders[keyToUpdate].map((item) => {
        if (item.item_id === itemId) {
          const maxQty = parseFloat(item.total_sellable_quantity) || 0;
          let validatedQty = newQty;
          if (newQty !== "" && parseFloat(newQty) > maxQty) {
            validatedQty = maxQty.toString();
          }

          return {
            ...item,
            quantity: validatedQty,
          };
        }
        return item;
      });

      setPastOrders({
        ...pastorders,
        [keyToUpdate]: updatedItems,
      });
    }
  };

  async function addtoBillFn(filteredItems) {
    const updatedData = [...(values?.data ?? [])]; // 👈 shared array

    const handleQuantityChange = async (
      qty,
      item,
      item_refill_days,
      item_shortage_qty,
      values,
      sharedUpdatedData
    ) => {
      const baseIndex = sharedUpdatedData.length;

      console.log(item, "fsdgfgdfgdfgdfgdfgdfg");

      // remove duplicate item
      const cleanedData = sharedUpdatedData.filter(
        (existingItem) => existingItem.item_id !== item.item_id
      );

      const stockApiUrl = `${url}/v1/inventory/stock/items?item_id=${item.item_id}&item_quantity=${qty}&cmr_phone_number=${values?.phone?.label}&item_discount_percentage=${values?.tempRowData?.item_discount_percentage}`;

      if (parseFloat(qty) > 0) {
        try {
          const stockApiResponse = await api.get(stockApiUrl);
          const batchDetail = stockApiResponse?.data?.data?.itemDetails;

          if (stockApiResponse?.data?.code === 200 && batchDetail?.length > 0) {
            for (
              let itemDetailIndex = 0;
              itemDetailIndex < batchDetail.length;
              itemDetailIndex++
            ) {
              const itemDetail = batchDetail[itemDetailIndex];

              console.log(itemDetail, "fsdgfgdfgdfgdfgdfgdfg");
              const itemBatchList = stockApiResponse.data.data?.itemBatchList;
              const updatedRowIndex = baseIndex + itemDetailIndex;

              const total_amount = (
                parseFloat(itemDetail.item_unit_price) *
                  parseFloat(itemDetail.quantity) -
                parseFloat(itemDetail.item_discount_amount)
              ).toFixed(2);

              const item_final_price = (
                total_amount / parseFloat(itemDetail.quantity) || 0
              ).toFixed(2);

              const item_margin_percentage =
                (
                  ((parseFloat(item_final_price) -
                    parseFloat(itemDetail.item_batch_final_purchase_rate)) /
                    parseFloat(itemDetail.item_batch_final_purchase_rate)) *
                  100
                ).toFixed(2) || 0;

              const updatedDataRow = {
                ...item,
                item_discount_amount: itemDetail.item_discount_amount,
                item_tax_amount: itemDetail.item_tax_amount.toFixed(2),
                item_discount_percentage:
                  itemDetail.item_discount_percentage || 0,
                item_unit_price: itemDetail.item_unit_price,
                item_price_wiithout_tax: (
                  parseFloat(itemDetail.item_unit_price) *
                    parseFloat(itemDetail.quantity) -
                    parseFloat(itemDetail.item_discount_amount) -
                    parseFloat(itemDetail.item_tax_amount) || 0
                ).toFixed(2),
                item_batch_number: itemDetail.batchNumber,
                item_rack_location: itemDetail.item_rack_location,
                item_batch_final_purchase_rate:
                  itemDetail.item_batch_final_purchase_rate || 0,
                item_exp_date: moment(itemDetail.expiryDate).format(
                  "YYYY-MM-DD"
                ),
                to_bin_id: itemDetail.to_bin_id,
                quantity: itemDetail.quantity,
                instock: true,
                item_gst: itemDetail.item_total_tax_percentage,
                item_sgst: (parseFloat(itemDetail.item_tax_amount) / 2).toFixed(
                  2
                ),
                item_cgst: (parseFloat(itemDetail.item_tax_amount) / 2).toFixed(
                  2
                ),
                item_igst: 0,
                item_final_price,
                item_margin_percentage,
                item_total_amount: total_amount,
                itemBatchList: itemBatchList ?? [],
                item_total_tax_percentage: itemDetail.item_total_tax_percentage,
                minDiscountPercentage:
                  parseFloat(itemDetail.minDiscountPercentage) || 0,
                maxDiscountPercentage:
                  parseFloat(itemDetail.maxDiscountPercentage) || 0,
                item_refill_days,
                item_shortage_qty,
                is_predefined_dis:
                  parseFloat(itemDetail.item_discount_percentage) > 0,
                item_loose_qty: item.total_sellable_quantity,
              };

              cleanedData.splice(updatedRowIndex, 0, updatedDataRow);
            }

            // Now update sharedUpdatedData reference
            sharedUpdatedData.length = 0; // Clear existing
            sharedUpdatedData.push(...cleanedData);
          } else {
            errorToast(
              `Product ${item.item_name} with quantity ${qty} is not available`
            );
          }
        } catch (error) {
          if (
            error?.response?.data?.data?.itemDetails?.item_sellable_quantity
          ) {
            errorToast(
              `${item.item_name} available quantity is ${error.response.data.data.itemDetails.item_sellable_quantity}`
            );
          } else {
            errorToast(
              error?.response?.data?.message ?? "Something went wrong"
            );
          }
        }
      } else {
        errorToast("Quantity should be greater than 0");
      }
    };

    for (let index = 0; index < filteredItems?.length; index++) {
      const itemData = filteredItems[index];
      const { quantity, item_refill_days, item_shortage_qty } = itemData;

      await handleQuantityChange(
        quantity,
        itemData,
        item_refill_days,
        item_shortage_qty,
        values,
        updatedData // 👈 pass shared reference
      );
    }

    const sot_total_gst = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_tax_amount || 0),
      0
    );
    const sot_total_discount = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_discount_amount || 0),
      0
    );
    const sot_sub_total = updatedData.reduce(
      (subtotal, item) =>
        subtotal +
        parseFloat(item?.item_unit_price || 0) *
          parseFloat(item?.quantity || 0),
      0
    );
    const sot_total_amount = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_total_amount || 0),
      0
    );
    const rounded_total = Math.round(sot_total_amount);
    const roundoff = (rounded_total - sot_total_amount)?.toFixed(2);

    setFieldValue("data", updatedData);
    setFieldValue("sot_total_gst", sot_total_gst.toFixed(2));
    setFieldValue("sot_total_discount", sot_total_discount.toFixed(2));
    setFieldValue("sot_sub_total", sot_sub_total.toFixed(2));
    setFieldValue("sot_total_amount", rounded_total.toFixed(2));
    setFieldValue("sot_round_off_value", roundoff);
    setFieldValue("sot_invoice_discount", 0);
    setFieldValue("sot_invoice_discount_percentage", 0);
    setFieldValue("sot_is_invoice_dis_percentage", false);
    setFieldValue("header_inv_dis_per", "");
    setOpen(false);
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          setOpen(false);
          setSelectedRow("");
          setSelectedItems([]);
        }}
      >
        <div className="fixed inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
          </Transition.Child>

          <div className="fixed inset-0 flex justify-end">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="h-full w-[400px] sm:w-[1000px] bg-white overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl">
                {/* Header */}
                <div
                  className="h-[61px] bg-[var(--slide-panel-head-bg)] px-3 flex items-center justify-between border-b"
                  style={{ borderColor: "var(--slide-panel-border)" }}
                >
                  <div
                    style={{
                      maxHeight: "32px",
                      color: "var(--slide-panel-h-fg)",
                      fontSize: "var(--slide-panel-h-fs)",
                      fontWeight: "var(--slide-panel-h-fw)",
                    }}
                    className="min-w-[75%] "
                  >
                    Past Bills & Top Products
                  </div>
                  <AddButton
                    onclkFn={() => {
                      setOpen(false);
                      // setProductDetails({ item_id: "" });
                    }}
                    icon={
                      <CloseIcon
                        width="12px"
                        height="12px"
                        fill="var(--close-button-fg)"
                      />
                    }
                    text={
                      <span>
                        Close <span className="opacity-50">(X)</span>{" "}
                      </span>
                    }
                    className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                  />
                </div>

                {/* Product Detail Panel */}
                <div
                  style={{
                    maxHeight: `calc(100% - 115px)`,
                    minHeight: `calc(100% - 115px)`,
                    height: `calc(100% - 115px)`,
                  }}
                >
                  <div className="px-3">
                    <TabsComponent
                      handleClickfn={(item) => {
                        setCurrentTab(item);
                        setSelectedItems([]);
                      }}
                      itemTabs={itemTabs}
                      setCurrentTab={setCurrentTab}
                      currentTab={currentTab}
                    />
                  </div>
                  {currentTab === "Past Bills" ? (
                    <div
                      style={{
                        maxHeight: `calc(100% - 4rem)`,
                        minHeight: `calc(100% - 4rem)`,
                        height: `calc(100% - 4rem)`,
                      }}
                      className="flex flex-col gap-5 px-3 "
                    >
                      <div className="tab-container h-[48%] border border-[var(--create-table-border)] rounded-[8px]">
                        <table className="w-full border-collapse mt-0   ">
                          <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                            <tr className="relative h-[50px]">
                              {pastBillsHeading
                                ?.filter(
                                  (heading) => heading?.enabled !== false
                                )
                                ?.map((heading, index) => (
                                  <th
                                    style={{
                                      minWidth: `${heading?.minWidth}px`,
                                    }}
                                    key={index}
                                    className={`px-3 whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                                  >
                                    <div
                                      className="flex items-center gap-2 w-full"
                                      style={{
                                        justifyContent:
                                          heading?.alignment === "right"
                                            ? "flex-end"
                                            : heading?.alignment === "center"
                                            ? "center"
                                            : "flex-start",
                                      }}
                                    >
                                      {heading?.label}
                                    </div>
                                  </th>
                                ))}
                            </tr>
                          </thead>
                          <tbody className="h-full">
                            {pastorders?.allItemsData?.map(
                              (rowData, rowIndex) => (
                                <tr
                                  onClick={() => {
                                    selectBillFun(
                                      rowData?.sot_id === selectedRow
                                        ? ""
                                        : rowData?.sot_id
                                    );
                                  }}
                                  className={` h-[50px] ${
                                    selectedRow === rowData?.sot_id
                                      ? "bg-[var(--create-table-sel-row-bg)]"
                                      : "hover:bg-[var(--create-table-row-hover-bg)] bg-[var(--create-table-row-bg)]"
                                  }    `}
                                  key={rowIndex}
                                >
                                  {pastBillsHeading
                                    ?.filter(
                                      (heading) => heading?.enabled !== false
                                    )
                                    ?.map((heading, index) => {
                                      return (
                                        <td
                                          style={{
                                            minWidth: `${heading?.minWidth}px`,
                                            textAlign: heading?.alignment, // Keep textAlign for normal text cells
                                          }}
                                          key={index}
                                          className="border-b border-[var(--create-table-border)] px-3 text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] text-[var(--create-table-row-fg-color)] whitespace-nowrap cursor-pointer"
                                        >
                                          {heading?.value === "actions" ? (
                                            rowData?.sot_id === selectedRow ? (
                                              <SelectIcon />
                                            ) : (
                                              ""
                                            )
                                          ) : (
                                            truncateString(
                                              rowData[heading.value] || "--",
                                              70
                                            )
                                          )}
                                        </td>
                                      );
                                    })}
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div className="tab-container h-[48%] border border-[var(--create-table-border)] rounded-[8px]">
                        <table className="w-full border-collapse mt-0   ">
                          <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                            <tr className="relative h-[50px]">
                              {pastProductsHeading
                                ?.filter(
                                  (heading) => heading?.enabled !== false
                                )
                                ?.map((heading, index) => (
                                  <th
                                    style={{
                                      minWidth: `${heading?.minWidth}px`,
                                    }}
                                    key={index}
                                    className={`px-3 whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)] text-left`}
                                  >
                                    {heading?.value === "action" ? (
                                      <input
                                        type="checkbox"
                                        checked={
                                          pastorders?.itemsData?.length > 0 &&
                                          pastorders?.itemsData?.every((item) =>
                                            selectedItems.includes(
                                              item?.item_id
                                            )
                                          )
                                        }
                                        onChange={(e) =>
                                          handleCheckboxChange(e, "all")
                                        }
                                        className="custom-checkbox form-check-input"
                                      />
                                    ) : (
                                      <div
                                        className="flex items-center gap-2 w-full"
                                        style={{
                                          justifyContent:
                                            heading?.alignment === "right"
                                              ? "flex-end"
                                              : heading?.alignment === "center"
                                              ? "center"
                                              : "flex-start",
                                        }}
                                      >
                                        {heading?.label}
                                      </div>
                                    )}
                                  </th>
                                ))}
                            </tr>
                          </thead>
                          <tbody className="h-full">
                            {pastorders?.itemsData?.length > 0 ? (
                              <>
                                {pastorders?.itemsData?.map(
                                  (rowData, rowIndex) => (
                                    <tr
                                      className={`hover:bg-[var(--create-table-row-hover-bg)] bg-[var(--create-table-row-bg)]  h-[50px] px-3 `}
                                      key={rowIndex}
                                    >
                                      {pastProductsHeading
                                        ?.filter(
                                          (heading) =>
                                            heading?.enabled !== false
                                        )
                                        ?.map((heading, index) => {
                                          return (
                                            <td
                                              style={{
                                                minWidth: `${heading?.minWidth}px`,
                                                textAlign: heading?.alignment, // Keep textAlign for normal text cells
                                              }}
                                              key={index}
                                              className="border-b border-[var(--create-table-border)] px-3 text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] text-[var(--create-table-row-fg-color)] whitespace-nowrap cursor-pointer"
                                            >
                                              {heading?.value === "action" ? (
                                                <input
                                                  type="checkbox"
                                                  checked={isItemChecked(
                                                    rowData
                                                  )}
                                                  id={rowData?.item_id}
                                                  onChange={(e) =>
                                                    handleCheckboxChange(e)
                                                  }
                                                  className="custom-checkbox form-check-input"
                                                />
                                              ) : heading?.value ===
                                                "quantity" ? (
                                                <input
                                                  disabled={
                                                    !isItemChecked(rowData)
                                                  }
                                                  type="number"
                                                  value={rowData.quantity || ""}
                                                  onChange={(e) =>
                                                    handleQuantityChange(
                                                      e,
                                                      rowData.item_id
                                                    )
                                                  }
                                                  className="min-h-[33px] px-2 border border-[var(--pay-met-input-border)] focus:outline-none bg-[var(--pay-met-input-bg)] text-[var(--pay-met-val-color)] text-[length:var(--pay-met-val-fs)] font-[var(--pay-met-val-fw)] border-radius input-field-no-spin-buttons w-[4rem]"
                                                />
                                              ) : (
                                                truncateString(
                                                  rowData[heading.value] ||
                                                    "--",
                                                  70
                                                )
                                              )}
                                            </td>
                                          );
                                        })}
                                    </tr>
                                  )
                                )}
                              </>
                            ) : (
                              <tr>
                                <td
                                  colSpan={
                                    pastProductsHeading?.filter(
                                      (h) => h?.enabled !== false
                                    ).length
                                  }
                                  className="text-center py-4 text-[length:var(--tab-empty-comp-fs)] border-b border-[var(--create-table-border)] font-[var(--tab-empty-comp-fw)] text-[var(--tab-empty-comp-fg)]"
                                >
                                  Pick a bill to see items
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        maxHeight: `calc(100% - 4rem)`,
                        minHeight: `calc(100% - 4rem)`,
                        height: `calc(100% - 4rem)`,
                      }}
                      className="flex flex-col gap-5 px-3 "
                    >
                      <div className="tab-container h-[48%] border border-[var(--create-table-border)] rounded-[8px]">
                        <table className="w-full border-collapse mt-0   ">
                          <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                            <tr className="relative h-[50px]">
                              {pastProductsHeading
                                ?.filter(
                                  (heading) => heading?.enabled !== false
                                )
                                ?.map((heading, index) => (
                                  <th
                                    style={{
                                      minWidth: `${heading?.minWidth}px`,
                                    }}
                                    key={index}
                                    className={`px-3 whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)] text-left`}
                                  >
                                    {heading?.value === "action" ? (
                                      <input
                                        type="checkbox"
                                        checked={
                                          pastorders?.topProducts?.length > 0 &&
                                          pastorders?.topProducts?.every(
                                            (item) =>
                                              selectedItems.includes(
                                                item?.item_id
                                              )
                                          )
                                        }
                                        onChange={(e) =>
                                          handleCheckboxChange(e, "all")
                                        }
                                        className="custom-checkbox form-check-input"
                                      />
                                    ) : (
                                      <div
                                        className="flex items-center gap-2 w-full"
                                        style={{
                                          justifyContent:
                                            heading?.alignment === "right"
                                              ? "flex-end"
                                              : heading?.alignment === "center"
                                              ? "center"
                                              : "flex-start",
                                        }}
                                      >
                                        {heading?.label}
                                      </div>
                                    )}
                                  </th>
                                ))}
                            </tr>
                          </thead>
                          <tbody className="h-full">
                            {pastorders?.topProducts?.length > 0 ? (
                              <>
                                {pastorders?.topProducts?.map(
                                  (rowData, rowIndex) => (
                                    <tr
                                      className={`hover:bg-[var(--create-table-row-hover-bg)] bg-[var(--create-table-row-bg)]  h-[50px] px-3 `}
                                      key={rowIndex}
                                    >
                                      {pastProductsHeading
                                        ?.filter(
                                          (heading) =>
                                            heading?.enabled !== false
                                        )
                                        ?.map((heading, index) => {
                                          return (
                                            <td
                                              style={{
                                                minWidth: `${heading?.minWidth}px`,
                                                textAlign: heading?.alignment, // Keep textAlign for normal text cells
                                              }}
                                              key={index}
                                              className="border-b border-[var(--create-table-border)] px-3 text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] text-[var(--create-table-row-fg-color)] whitespace-nowrap cursor-pointer"
                                            >
                                              {heading?.value === "action" ? (
                                                <input
                                                  type="checkbox"
                                                  checked={isItemChecked(
                                                    rowData
                                                  )}
                                                  id={rowData?.item_id}
                                                  onChange={(e) =>
                                                    handleCheckboxChange(e)
                                                  }
                                                  className="custom-checkbox form-check-input"
                                                />
                                              ) : heading?.value ===
                                                "quantity" ? (
                                                <input
                                                  disabled={
                                                    !isItemChecked(rowData)
                                                  }
                                                  type="number"
                                                  value={rowData.quantity || ""}
                                                  onChange={(e) =>
                                                    handleQuantityChange(
                                                      e,
                                                      rowData.item_id
                                                    )
                                                  }
                                                  className="min-h-[33px] px-2 border border-[var(--pay-met-input-border)] focus:outline-none bg-[var(--pay-met-input-bg)] text-[var(--pay-met-val-color)] text-[length:var(--pay-met-val-fs)] font-[var(--pay-met-val-fw)] border-radius input-field-no-spin-buttons w-[4rem]"
                                                />
                                              ) : (
                                                truncateString(
                                                  rowData[heading.value] ||
                                                    "--",
                                                  70
                                                )
                                              )}
                                            </td>
                                          );
                                        })}
                                    </tr>
                                  )
                                )}
                              </>
                            ) : (
                              <tr>
                                <td
                                  colSpan={
                                    pastProductsHeading?.filter(
                                      (h) => h?.enabled !== false
                                    ).length
                                  }
                                  className="text-center py-4 text-[length:var(--tab-empty-comp-fs)] border-b border-[var(--create-table-border)] font-[var(--tab-empty-comp-fw)] text-[var(--tab-empty-comp-fg)]"
                                >
                                  No Products Available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
                <div className="flex justify-between h-[50px] items-center px-3">
                  <span></span>
                  <AddButton
                    ref={addref}
                    prefixIcon={false}
                    text={
                      <span>
                        Add to Bill <span className="opacity-50">(A)</span>{" "}
                      </span>
                    }
                    className="flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]                     
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-font-size)] 
    font-[var(--primary-button-font-weight)]"
                    type="button"
                    onclkFn={() => {
                      const sourceData =
                        currentTab === "Past Bills"
                          ? pastorders?.itemsData
                          : pastorders?.topProducts;

                      const filteredItems = sourceData?.filter(
                        (item) => parseFloat(item.quantity) > 0
                      );

                      addtoBillFn(filteredItems);
                    }}
                  />
                </div>

                <LoadingOverlay loading={loading} />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

const pastBillsHeading = [
  {
    label: "Invoice #",
    value: "sot_invoice_number",
  },
  {
    label: "Customer Name",
    value: "cmr_first_name",
  },
  {
    label: "Mobile",
    value: "cmr_phone_number",
  },
  {
    label: "Invoice Date",
    value: "created_date",
  },
  {
    label: "Amount",
    value: "sot_total_amount",
  },
  {
    label: "",
    value: "actions",
  },
];
const pastProductsHeading = [
  {
    label: "",
    value: "action",
  },
  {
    label: "Product Name",
    value: "item_name",
  },
  {
    label: "Sold Qty",
    value: "total_sellable_quantity",
  },
  {
    label: "Rate",
    value: "item_unit_price",
  },
  {
    label: "Amount",
    value: "item_total_amount",
  },
  {
    label: "Disc %",
    value: "item_discount_percentage",
  },
  {
    label: "MRP",
    value: "item_unit_price",
  },
  {
    label: "Avl Qty",
    value: "total_sellable_quantity",
  },
  {
    label: "Qty ",
    value: "quantity",
  },
];
